import ListingsApiEndpoints from './listings.api';
import AddOnsApiEndpoints from './add-ons.api';
import BookingsApiEndpoints from './booking.api';
import PayoutsApiEndpoints from './payouts.api';
import ReportingApiEndpoints from './reporting.api';
import * as helpers from '../helpers';
import EntitiesApiEndpoints from './entities.api';

const HostApi = {
  ...helpers,
  listings: ListingsApiEndpoints,
  addOns: AddOnsApiEndpoints,
  bookings: BookingsApiEndpoints,
  payouts: PayoutsApiEndpoints,
  reporting: ReportingApiEndpoints,
  entities: EntitiesApiEndpoints,
};

export default HostApi;
